/**
 * Coupons Module
 *
 * Handles coupon-specific functionality including:
 * - Filters for coupon list
 * - Form validation
 * - Discount type switching
 */

import { $, ready } from '../utils/dom.js';

const BASE_URL = '/coupons';

// =============================================================================
// Filters
// =============================================================================

/**
 * Apply filters (type and status)
 */
export function applyFilters(select) {
    const typeSelect = $('select[name="type"]');
    const statusSelect = $('select[name="status"]');

    const type = typeSelect?.value || '';
    const status = statusSelect?.value || '';

    const params = new URLSearchParams();
    if (type) params.append('type', type);
    if (status) params.append('status', status);

    window.location.href = BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Clear filters
 */
export function clearFilters() {
    window.location.href = BASE_URL;
}

// =============================================================================
// Form Validation
// =============================================================================

/**
 * Initialize coupon form validation
 */
function initCouponFormValidation() {
    const form = $('#coupon-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
        const code = $('#code')?.value.trim();
        const discountType = $('#discount_type')?.value;
        const discountValue = $('#amount')?.value;

        if (!code) {
            alert('Please enter a coupon code');
            e.preventDefault();
            return;
        }

        if (!discountType) {
            alert('Please select a discount type');
            e.preventDefault();
            return;
        }

        if (discountType !== 'free_shipping' && (!discountValue || parseFloat(discountValue) <= 0)) {
            alert('Please enter a valid discount value');
            e.preventDefault();
            return;
        }

        if (discountType === 'percentage' && parseFloat(discountValue) > 100) {
            alert('Percentage discount cannot exceed 100%');
            e.preventDefault();
            return;
        }
    });
}

/**
 * Initialize coupon code auto-uppercase
 */
function initCouponCodeUppercase() {
    const codeInput = $('#code');
    if (!codeInput) return;

    codeInput.addEventListener('input', function(e) {
        e.target.value = e.target.value.toUpperCase();
    });
}

/**
 * Initialize discount type switching
 */
function initDiscountTypeSwitcher() {
    const discountTypeSelect = $('#discount_type');
    if (!discountTypeSelect) return;

    const discountAmountField = $('#discount-amount-field');
    const discountValueInput = $('#amount');
    const currencySymbol = $('#currency-symbol');
    const percentageSymbol = $('#percentage-symbol');

    function updateDiscountUI() {
        const type = discountTypeSelect.value;

        if (type === '') {
            if (discountAmountField) discountAmountField.classList.add('hidden');
            return;
        }

        if (discountAmountField) discountAmountField.classList.remove('hidden');

        if (type === 'percentage') {
            if (discountValueInput) {
                discountValueInput.placeholder = '0';
                discountValueInput.max = '100';
            }
            if (currencySymbol) currencySymbol.classList.add('hidden');
            if (percentageSymbol) percentageSymbol.classList.remove('hidden');
        } else if (type === 'fixed_cart' || type === 'fixed_product') {
            if (discountValueInput) {
                discountValueInput.placeholder = '0.00';
                discountValueInput.max = '';
            }
            if (currencySymbol) currencySymbol.classList.remove('hidden');
            if (percentageSymbol) percentageSymbol.classList.add('hidden');
        } else if (type === 'free_shipping') {
            if (discountAmountField) discountAmountField.classList.add('hidden');
        }
    }

    discountTypeSelect.addEventListener('change', updateDiscountUI);
    updateDiscountUI();
}

// =============================================================================
// Auto-Initialization
// =============================================================================

function initCoupons() {
    initCouponFormValidation();
    initCouponCodeUppercase();
    initDiscountTypeSwitcher();
}

ready(initCoupons);

// Expose globally for legacy onclick handlers
window.applyFilters = window.applyFilters || applyFilters;
window.clearFilters = window.clearFilters || clearFilters;

export default {
    applyFilters,
    clearFilters
};
